import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './clerks.actions.js';
import getters from './clerks.getters.js';
import mutations from './clerks.mutations.js';
import state from './clerks.state.js';

BaseStore.registerModule('clerks', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('clerks');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
